import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const getPayMeMetricCardsData = ({
  isLive,
  handle,
  dateRange,
  branch,
  currency,
}: {
  isLive: boolean;
  handle: string;
  dateRange: {
    start_date: string;
    end_date: string;
  };
  branch?: string | null;
  currency?: string | null;
}) => {
  const params: Record<string, string | boolean> = {
    is_live: isLive,
    date_from: dateRange.start_date,
    date_to: dateRange.end_date,
    origin: 'PayMe',
  };

  if (branch) {
    params.branch = branch;
  }

  if (currency) {
    params.currency = currency;
  }

  return axiosPrivate.get(`/dashboard/v1/payment-handle/${handle}/statistics`, {
    params: params,
  });
};

